import { getStepList } from '@/views/openAccount/step.config';
import router from '@/router/openAccount';
import { customizeRequest, ApplySubmit, ApplyDetail } from '@/apis/openAccount';
import { Toast } from 'vant';
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js';
import { getQueryString } from '@/utils';
import changeChannelService from '@/components/changeChannelDialog/service';
// 香港开户相关的状态
import { HK_getters } from './accountHk';
import eventTrack from '../../config/eventTrack';
import initI18n from '../../i18n/tools';
import zhLocale from '../../i18n/openAccount/zh_cn'; // 本地定义的简体中文
import tcLocale from '../../i18n/openAccount/zh_tc'; // 本地定义的繁体中文
import enLocale from '../../i18n/openAccount/en_us'; // 本地定义的繁体中文
const i18n = initI18n({ zhLocale, tcLocale, enLocale });
// 开户步骤版本, 前端管理
const StepVersion = '1.0';
/**
 * 开户填写的所有资料
 * 注意： _ 开头的字段，是后台未定义的字段，暂不使用
 *  */
const state = {
    clientType: '', // cn：内地开户，hk：香港开户，默认为空不选中
    oaType: '', // 对应接口的 oaType, 开户方式：1-大陆地区CA开户；2-香港地区入金开户
    aecode: '', // 用户的渠道码 aecode
    channel: '', // 渠道 channel
    clientStatus: 0, // 开户状态，是否开户  33: 开户中...
    appId: 0, // 开户流程id
    hlId: 0, // 开户成功后 恒利id
    clientInfo: {}, // 这个对象有 subAccountId 只有开户成功的用户才有这个值，在开户成功之后继续入金需要携带这个参数
    stepVersion: StepVersion, // 步骤版本
    applyStepsName: [], //openAccountSteps.map(item => item.name), // 开户步骤 name 属性 ，用来跳转页面
    currentStep: '', // 当前步骤
    latestStep: '', // 停留的步骤
    applyStatus: 0, // 开户进度状态
    cashInStatus: '', // 香港开户的入金状态
    stockStatus: '', // 预开户的转仓状态
    rejectData: {}, // 驳回信息
    cashInData: {}, // 香港开户-出入金驳回的信息
    source: undefined, // 开户来源
    // ------------------------------------------ 身份证页面 IdCardPage ------------------------------------------
    chineseName: '', // 中文名称
    englishName: '', // 英文名称 ｜ 拼音名称
    lastName: '', // HK - 姓 -英文
    firstName: '', // HK - 名 -英文
    idType: 1, // 证件类型 : 1-身份证 Identity Card；2-护照 Passport；3-营业执照 Business Registration；4-签证 C.I.
    idNumber: '', // 身份证号码
    idAddress: '', // 证件地址
    idAuthority: '', // 签发机关 ｜ 签发国家/地区
    idValidTime: '', // 证件有效期
    birthday: '', // 出生日期
    idCountry: '', // 身份证所在国家，页面不展示，提供后台使用
    gender: '', // 性别： 1:男， 2-女
    birthCity: '', // 出生地点
    birthCountry: '', //  生国家：2位国家码 // 只是传给后台使用，前端没有展示
    nationality: '', // 国籍：2位国家码
    permanentResident: undefined, // 是否是香港地区的永久居民 1是、2否
    idExtraInfo: {
        // 非永居下的永居证件信息
        permanent: {
            idType: null,
            idNumber: '', // 永居证件号码
            idCountry: '', // 永居证件国家
        },
        // 香港非永居证件信息（从Statement页面传入）
        idcardHK: {
            idType: null, // 香港身份证类型
            idCountry: '', // 中国香港
            idNumber: '', // 香港身份证号码
        },
    },
    documentInfo: {
        idCard: [
        //     {           // 内地开户 - 身份证正反面信息
        //     url: '',
        //     description: '身份证-人像面',
        //     ossId: '',
        //     ossCategory: 'UserApply',
        // },{
        //     url: '',
        //     description: '身份证-国徽面',
        //     ossId: '',
        //     ossCategory: 'UserApply',
        // }
        ],
        CropIdCard: [
        // 跟 idCard 顺序对应，用于存储 idCard 被裁剪之后的照片
        // {
        //     ossId: ''
        // }
        ],
        nonMainlandDocument: [
            {
                // 非内地开户的真身份证
                url: '',
                description: '身份证-正面',
                ossId: '',
                ossCategory: 'UserApply',
            },
        ],
        proofOfAddress: [
            {
                // 香港开户-地址证明
                url: '',
                description: '地址证明',
                ossId: '',
                ossCategory: 'UserApply',
            },
        ],
        idCardHK: [
        // 香港非永居身份证照片
        // {
        //     url: '',
        //     description: 'ZM-香港-非永居-正面',
        //     ossId: '',
        //     ossCategory: 'UserInfo',
        // }
        ],
    },
    contactInfo: {
        // 一些地址信息
        residentialAddress: '', // 住宅地址
        residentialAddressCountry: '', // 住宅地址的国家码
        residentialAddressCity: '', // 居住城市 - HK
        mailingAddress: '', //通信地址
        mailingAddressCountry: '', // 通信地址的国家码
    },
    // ------------------------------------------ 银行卡页面 BankCardPage ------------------------------------------
    acctNumber: '', // 开户银行卡号
    phone: '', // 手机号码
    email: '', // 电子邮箱
    defaultLanguage: 'zhTc', // 结单语言 // zhTc zhCn en
    // ------------------------------------------ 职业状况 JobStatusPage ------------------------------------------
    employmentInfo: {
        degree: '', // 最高学历
        employment: '', // 职业状态
        companyName: '', // 公司名称
        companyNameVendor: '', // 公司名称-天眼查
        officeAddress: '', // 办公室地址
        officeAddressVendor: '', // 办公地址-天眼查
        industry: '', // 行业
        position: '', // 职位
        workLife: '', // 工作年期
        investFundsSource: '', // 投资资金来源
        financialStatus: '', // 财务状况 有-无债务
        financialStatusDetail: '', // 其它债务说明
    },
    // ------------------------------------------ 财务状况 FinancePage ------------------------------------------
    financialInfo: {
        fundsSource: '', // 收入来源
        annualIncome: '', // 年收入
        netAsset: '', // 净资产
        currentAsset: '', // 可投资资产（港元）
        annualAverageInvestAmount: '', // 每年平均投资金额（港元）
        houseType: '', // 住宅类别
        version: 2
    },
    // ------------------------------------------ 投资经验 InvestmentPage ------------------------------------------
    investmentInfo: {
        hkStock: 1, // 股票投资经验
        preciousMetals: 1, // 金银投资经验
        foreignExchange: 1, // 外汇投资经验
        aShares: 1, // A 股投资经验
        fund: 1, // 基金投资经验
        investGoal: '', // 投资目的
    },
    derivativeInfo: {
        // 衍生品
        /** 这里包含很多信息 */
        derivative: {
            checked: '',
        }, // 有｜无意购买衍生品 true： 有意， false: 无意
        risk: {
            checked: false,
        }, // '您是否了解衍生产品的主要特征及风险',
        trainingCourse: {
            title: '我曾接受有关介绍衍生产品之性质及风险的培训或课程。',
            checked: false,
            selectIndex: '',
            selectContent: '', // 保存信息，在设置页面数据的时候不会用到
        },
        experienceRelated: {
            title: '我现时或过往的工作经验/业务与衍生产品有关。',
            checked: false,
        },
        workExperience: {
            title: '我现时或过往的工作经验/业务与衍生产品有关。与其相关职业和性质为：',
            checked: false,
            selectIndex: '0',
            selectContent: '', // 保存信息，在设置页面数据的时候不会用到
        },
        yearsParticipation: {
            title: '我现时或过往的与衍生产品有关的工作经验/业务的服务年期为：',
            checked: false,
            selectIndex: '0',
            selectContent: '', // 保存信息，在设置页面数据的时候不会用到
        },
        derivativeProducts: {
            title: '我有买卖衍生产品的经验。',
            checked: false,
            selectIndex: '',
            selectContent: '', // 保存信息，在设置页面数据的时候不会用到
        },
    },
    // ------------------------------------------ 选择账户 SelectAccountPage ------------------------------------------
    accountType: 0, // 证券账户类型bit位：1-cash; 2-margin', 3表示cash+margin
    marketOpen: undefined, // '开通证券市场bit位：1-股证；2-美股；4-沪深',7表示三者都开通
    openFundTrade: 1, // 是否开通基金交易标记：0-不开通；1-开通，默认为0
    // ------------------------------------------ 身份披露 DisclosurePage ------------------------------------------
    identityExposureInfo: 1,
    amlConfirmInfo: {},
    // ------------------------------------------ 风险披露  ------------------------------------------
    disclosureId: 0, // 全部提交
    // ------------------------------------------ 税务信息 TaxInfoPage ------------------------------------------
    taxInfo: {
    // key: value
    // key = 国家码； value = 税务编号
    },
    w8Info: {
        country: '', // 国家
        countryCode: '', // 国家码
        mailingAddress: '', // 通讯地址
        residenceAddress: '', // 住宅地址
        mailingAddressmailingAddress: '', // 兼容旧字段名（原代码中的拼写错误）
    },
    // ------------------------------------------ 签署协议 Signature ------------------------------------------
    customerSignature: [
        {
            url: '',
            description: '',
            ossId: '',
            ossCategory: '',
        },
    ],
    // ------------------------------------------ 活体识别 LivingWitness ------------------------------------------
    livingBodyVerifyId: null,
    // ------------------------------------------ 申请证书 CaApply ------------------------------------------
    caInfoId: 0,
    // 改变这个字段时，触发index.vue获取数据，相当于刷新全局状态
    fetchFlag: 0,
    // app 来源标识
    fromPage: '',
    // 后台提供给 H5 自定义存储数据的一个对象，注意后台存储是全量替换，如要合并存储需要前端自行处理
    frontInfo: {
        /**
         * ... 自行存储
         * 为了数据名称作区分，统一使用前缀  RAW_xxx;
         * 如：RAW_taxInfo、RAW_w8Info
         */
        RAW_taxInfo: [],
        surnamePinyinModify: 0,
        RAW_amlConfirmInfoTime: 0, // 时间戳 反洗钱的上一次提交时间，七天之内不用再提示反洗钱提示框
    },
    // y项目资产数据
    protocolStatus: 0,
    statementInfo: {},
};
const getters = {
    /** 获取开户进度 */
    getClientStatus(state) {
        return state.clientStatus;
    },
    /** 获取客户的开户类型 */
    getClientType(state) {
        return state.clientType;
    },
    // 是否为内地开户类型
    isCNClientType(state) {
        return state.clientType === 'cn';
    },
    /** 获取开户所有信息 */
    getOpenAccount(state) {
        return state;
    },
    /** 获取渠道码 */
    getCodeOrChannel(state) {
        return {
            aecode: state.aecode || '',
            channel: state.channel || '',
        };
    },
    /** 获取基本信息 */
    getUserInfo(state) {
        return {
            appId: state.appId,
            stepVersion: state.stepVersion || StepVersion,
            currentStep: state.currentStep,
            applyStatus: state.applyStatus,
            source: state.source,
            applyItems: state.applyItems,
            currentApplyItem: state.currentApplyItem,
            oaType: state.oaType,
            cashInStatus: state.cashInStatus,
            stockStatus: state.stockStatus,
            clientType: state.clientType,
            w8Info: state.w8Info,
        };
    },
    /** 获取身份证验证页面信息 */
    getIdCardPage(state) {
        return {
            chineseName: state.chineseName,
            englishName: state.englishName,
            firstName: state.firstName,
            lastName: state.lastName,
            idType: state.idType,
            idNumber: state.idNumber,
            idAddress: state.idAddress,
            idAuthority: state.idAuthority,
            idValidTime: state.idValidTime,
            birthday: state.birthday,
            idCountry: state.idCountry,
            gender: state.gender,
            birthCity: state.birthCity,
            birthCountry: state.birthCountry,
            documentInfo: state.documentInfo,
            contactInfo: state.contactInfo,
            idExtrainfo: state.idExtrainfo,
            rejectData: state.rejectData,
        };
    },
    /** 获取用户年龄 */
    getUserAge(state) {
        if (!state.birthday)
            return null;
        const birthDate = new Date(state.birthday.replace(/\//g, '-'));
        const currentDate = new Date();
        let age = currentDate.getFullYear() - birthDate.getFullYear();
        const monthDiff = currentDate.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    },
    /** 判断是否为65-75岁用户，能到后续流程的都是小于 75 岁的。但随着时间推移，可能会超过 75 岁 所以这里只判断大于等于 65 岁*/
    isAge65To75(state, getters) {
        const age = getters.getUserAge;
        return age !== null && age >= 65;
    },
    /** 获取银行卡页面信息 */
    getBankCardPage(state) {
        return {
            acctNumber: state.acctNumber,
            phone: state.phone,
            email: state.email,
            defaultLanguage: state.defaultLanguage,
            rejectData: state.rejectData,
        };
    },
    /** 获取职业状况页面信息 */
    getJobStatusPage(state) {
        return state.employmentInfo;
    },
    /** 获取财务状况信息 */
    getFinancePage(state) {
        return state.financialInfo;
    },
    /** 获取投资经验页面信息 */
    getInvestmentPage(state) {
        return {
            hkStock: state.investmentInfo.hkStock,
            preciousMetals: state.investmentInfo.preciousMetals,
            foreignExchange: state.investmentInfo.foreignExchange,
            aShares: state.investmentInfo.aShares,
            fund: state.investmentInfo.fund,
            investGoal: state.investmentInfo.investGoal,
            derivativeInfo: state.derivativeInfo,
            // investmentInfo: state.investmentInfo
        };
    },
    /** 获取选择账户页面 */
    getSelectAccountPage(state) {
        return {
            accountType: state.accountType,
            marketOpen: state.marketOpen,
            openFundTrade: state.openFundTrade,
        };
    },
    /** 获取风险披露页面信息 */
    getDisclosurePage(state) {
        return {
            disclosureId: state.disclosureId,
        };
    },
    /** 获取风险披露反洗钱问题页面信息 */
    getAmlQuestionPage(state) {
        return {
            amlConfirmInfo: state.amlConfirmInfo,
        };
    },
    /** 获取税务信息页面信息 */
    getTaxInfoPage(state) {
        return {
            taxInfo: state.taxInfo,
            w8Info: state.w8Info,
            idNumber: state.idNumber,
            idAddress: state.idAddress,
            idCountry: state.idCountry,
            oaType: state.oaType,
            nationality: state.nationality,
            permanentResident: state.permanentResident,
            idExtraInfo: state.idExtraInfo,
            frontInfo: state.frontInfo,
            statementInfo: state.statementInfo, // 添加 statementInfo 以获取香港非永居选择信息
        };
    },
    /** 获取签署协议页面信息 */
    getSignaturePage(state) {
        return {
            customerSignature: state.customerSignature,
        };
    },
    // 获取活体识别页面信息
    getLivingWitnessPage(state) {
        return {
            livingBodyVerifyId: state.livingBodyVerifyId,
        };
    },
    // 获取证书申请页面信息
    getCaApplyPage(state) {
        return {
            caInfoId: state.caInfoId,
        };
    },
    // 获取驳回信息
    getRejectData(state) {
        return state.rejectData;
    },
    // 获取姓名，中 -> 英
    getName(state) {
        return state.chineseName || state.englishName || '';
    },
    ...HK_getters,
    // 获取停留（后台保存）的步骤
    getLatestStep(state) {
        return state.latestStep;
    },
    // 获取自定义存储数据
    getFrontInfo(state) {
        return state.frontInfo;
    },
    getProtocolStatus(state) {
        return state.protocolStatus;
    },
    // 获取结单信息
    getStatementInfo(state) {
        return {
            statementInfo: state.statementInfo,
            documentInfo: state.documentInfo, // 图片等信息
            idExtraInfo: state.idExtraInfo, // 香港身份证额外信息
        };
    },
    // 牛股王客户
    isNGWAccount(state) {
        var _a;
        return ((_a = state.statementInfo) === null || _a === void 0 ? void 0 : _a.source) === 'NGW';
    },
};
const mutations = {
    /** 设置任意页面信息 */
    setArbitrarilyPage(state, option) {
        for (const i in option) {
            if (typeof option[i] === 'object') {
                //['number', 'string', 'boolean']
                state[i] = Object.assign(state[i], option[i]);
            }
            else {
                state[i] = option[i];
            }
        }
    },
    /** 将 state 里面的任意属性设置为某个值 而不是  Object.assign */
    setStateData(state, option) {
        for (const i in option) {
            state[i] = option[i];
        }
    },
    setClientType(state, option) {
        state.clientType = option.clientType;
        //state.applySteps = getStepList(option.clientType).map(item => item.key) // 设置默认开户步骤 ，与中台匹配
        // 如果 结单开关打开 不过滤结单页 // 只有驳回的时候才会有 option.applyStepsName
        state.applyStepsName =
            (option === null || option === void 0 ? void 0 : option.applyStepsName) ||
                getStepList(option.clientType)
                    .map((item) => item.name)
                    .filter((item) => {
                    return localStorage.getItem('statementLimitType') === '1' /* 结单打开 */ &&
                        localStorage.getItem('strict') === 'true' /* 内地开户受限 */
                        ? true
                        : item !== 'STATEMENT';
                });
        // 针对能跳过结单页的情况，将结单页放到步骤列表的最后面
        if (localStorage.getItem('statementSkipType') === '1') {
            const statementIndex = state.applyStepsName.indexOf('STATEMENT');
            if (statementIndex !== -1) {
                const [statement] = state.applyStepsName.splice(statementIndex, 1);
                state.applyStepsName.push(statement);
            }
        }
    },
    setOpenAccount(state, option) {
        state.aecode = option.aecode;
        state.channel = option.channel;
    },
    setClientStatus(state, status) {
        state.clientStatus = status;
    },
    setApplyStatus(state, status) {
        state.applyStatus = status;
    },
    setSource(state, source) {
        state.source = source;
    },
    setHlid(state, hlId) {
        state.hlId = hlId;
    },
    setSteps(state, steps) {
        state.applySteps = steps;
    },
    setCurrentStep(state, step) {
        state.currentStep = step;
    },
    setClientInfo(state, option) {
        state.clientInfo = option;
    },
    setFetchFlag(state) {
        state.fetchFlag += 1;
    },
    setFromPage(state, type) {
        state.fromPage = type;
    },
    setLatestStep(state, step) {
        state.latestStep = step;
    },
    setProtocolStatus(state, status) {
        state.protocolStatus = status;
    },
};
const actions = {
    upStateData({ commit }, option) {
        commit('setStateData', option);
    },
    upClientInfo({ commit }, option) {
        commit('setClientInfo', option);
    },
    upClientType({ commit }, option) {
        commit('setClientType', option);
    },
    upOpenAccount({ commit }, option) {
        commit('setOpenAccount', option);
    },
    /** 更新用户的所有信息 */
    upALlUserInfo({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    /** 更新身份验证页面信息 */
    upIdCardPage({ commit }, option) {
        commit('setStateData', option);
    },
    upBankCardPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upJobStatusPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upFinancePage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upInvestmentPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upSelectAccountPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upDisclosurePage({ state }, option) {
        state.disclosureId = option.disclosureId;
    },
    upAmlQuestionPage({ state }, option) {
        state.amlConfirmInfo = option.amlConfirmInfo;
    },
    upTaxInfoPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upSignaturePage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upLivingWitnessPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    upCaApplyPage({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    updateApplyStatus({ commit }, status) {
        commit('setApplyStatus', status);
    },
    updateSource({ commit }, source) {
        commit('setSource', source);
    },
    updateClientStatus({ commit }, status) {
        commit('setClientStatus', status);
    },
    updateHlid({ commit }, hlId) {
        commit('setHlid', hlId);
    },
    updateApplySteps({ commit }, steps = []) {
        commit('setSteps', steps);
    },
    upUserInfo({ commit }, option) {
        commit('setStateData', option);
    },
    updateCurrentStep({ commit }, step) {
        console.log('🚀 ~ updateCurrentStep ~ step:', step);
        commit('setCurrentStep', step !== null && step !== void 0 ? step : '');
    },
    updateLatestStep({ commit }, step) {
        commit('setLatestStep', step !== null && step !== void 0 ? step : '');
    },
    upStatementInfo({ commit }, option) {
        commit('setArbitrarilyPage', option);
    },
    // 提交开户申请之前的前置检查
    async submitApplyWithCheck({ commit, dispatch, state }, options) {
        const { message = i18n.t('OpenStatus.khsqytj'), checkAeCode = true } = options || {};
        // 检查链接的aeCode和用户已填的AeCode是否相等
        if (checkAeCode) {
            // 获取用户最新的aeCode和Channel
            await customizeRequest(ApplyDetail, async (detailRes) => {
                const { result } = detailRes.data;
                await dispatch('upOpenAccount', {
                    aecode: result.aeCode || '',
                    channel: result.channel || '',
                });
            });
            // 链接或sessionStorage的aeCode和Channel
            const linkAeCode = getQueryString('aeCode') || sessionStorage.getItem('openEntryAeCode') || '';
            const linkChannel = getQueryString('channel') || sessionStorage.getItem('openEntryChannel') || '';
            const { aecode, channel } = state;
            if (linkAeCode && (linkAeCode !== aecode || linkChannel !== channel)) {
                changeChannelService.show({
                    aeCode: aecode,
                    channel,
                    linkAeCode,
                    linkChannel,
                });
            }
            else {
                dispatch('submitApply', message);
            }
        }
        else {
            dispatch('submitApply', message);
        }
    },
    // 提交
    async submitApply({ commit, state }, message = i18n.t('OpenStatus.khsqytj')) {
        await customizeRequest(ApplySubmit, async () => {
            // debugger
            // adjust 埋点
            JSBridge && JSBridge.event_track({ event: eventTrack.Open_Account_Applied_For });
            // 开户状态置为2000，刷新后再同步后台状态
            Toast.success(message);
            // 同步状态
            const { data } = await ApplyDetail();
            const { status } = data === null || data === void 0 ? void 0 : data.result;
            commit('setApplyStatus', status);
            // 重新获取开户数据
            commit('setFetchFlag');
            if (state.oaType != 1) {
                //香港开户的最后一步跳转
                // 只要是最后一步就提交数据
                if (state.rejectData.steps && state.cashInStatus !== 1000) {
                    // 如果是驳回流程 ，资料填写完成就提交数据并跳转状态页 ,或者 驳回状态且没有入金，跳转到入金中间页面
                    router.push({
                        name: 'ACCOUNTSTATUS',
                    });
                }
                else {
                    // 如果是正常开户流程 - 跳转出入金中间页
                    router.push({
                        name: 'TRANSITIONGOLD',
                    });
                }
            }
            else {
                // 内地的最后一步直接提交
                if (state.rejectData.steps) {
                    router.push({
                        name: 'openStatus',
                    });
                }
                else {
                    if (status === 1500) {
                        router.push({
                            name: 'TRANSITIONGOLD',
                        });
                    }
                    else if (status === 1600) {
                        if (JSBridge) {
                            JSBridge === null || JSBridge === void 0 ? void 0 : JSBridge.close();
                        }
                        else {
                            window.location.href = `/pages/startAccount.html#/`;
                        }
                    }
                    else {
                        router.push({
                            name: 'openStatus',
                        });
                    }
                }
            }
        }, {
            message: i18n.t('OpenStatus.khqqtjsb'),
            errorHandler: (res) => {
                const { code } = (res === null || res === void 0 ? void 0 : res.data.error) || {};
                if (code === 150211) {
                    router.push({ name: 'STATEMENT', query: { supplement: 'supplement' } });
                }
            },
        });
    },
    upFetchFlag({ commit }) {
        commit('setFetchFlag');
    },
    // 获取下一步骤，根据传入的当前步骤，不传则返回第一步
    getNextStep({ state }, currentStep) {
        let nextStep = currentStep;
        if (!currentStep) {
            console.log(state.applyStepsName);
            nextStep = state.applyStepsName[0];
        }
        else {
            const currIndex = state.applyStepsName.findIndex((step) => step === currentStep);
            nextStep = state.applyStepsName[currIndex > -1 ? currIndex + 1 : 0];
        }
        return nextStep !== null && nextStep !== void 0 ? nextStep : currentStep;
    },
    // 获取当前页面在数组列表中的位置
    getIndex({ state }, route) {
        const routerName = route.name;
        let routerIndex = null;
        for (const ri in state.applyStepsName) {
            if (state.applyStepsName[ri] == routerName) {
                // 匹配到路由名称相同就标记
                routerIndex = Number(ri) * 1; // 转换为数字
                break;
            }
        }
        return routerIndex;
    },
    // 上一步跳转
    async goPrevPage({ state, dispatch }, { route, option } = {}) {
        if (option) {
            router.push(option);
        }
        else {
            const currentIndex = await dispatch('getIndex', route);
            const goPageIndex = currentIndex === 0 ? 0 : currentIndex - 1;
            const currentStepName = state.applyStepsName[goPageIndex];
            await dispatch('updateCurrentStep', currentStepName);
            if (!currentStepName) {
                console.error(i18n.t('OpenStatus.lymcppsbl'), { currentIndex, goPageIndex, currentStepName });
            }
            else {
                router.push({
                    name: currentStepName,
                });
            }
        }
    },
    // 下一步跳转
    async goNextPage({ state, dispatch }, { route, option } = {}) {
        if (option) {
            router.push(option);
        }
        else {
            const currentIndex = await dispatch('getIndex', route);
            console.log('currentIndex', 'currentIndex =', currentIndex, 'state.applyStepsName.length =', state.applyStepsName.length);
            if (currentIndex ===
                state.applyStepsName.length - 1 /* ||
            state.applyStatus == foreignIDAuditStatusCode ||
            state.applyStatus == rejectTodoStatusCode */) {
                // 最后一步
                await dispatch('submitApplyWithCheck');
            }
            else {
                const goPageIndex = currentIndex + 1;
                const currentStepName = state.applyStepsName[goPageIndex];
                await dispatch('updateCurrentStep', currentStepName);
                await dispatch('updateLatestStep', currentStepName);
                // 正常流程的下一步
                if (!currentStepName) {
                    console.error(i18n.t('OpenStatus.lymcppsbl'), { currentIndex, goPageIndex, currentStepName });
                }
                else {
                    router.push({
                        name: currentStepName,
                    });
                }
            }
        }
    },
    // 设置app 来源标识
    upFromPage({ commit }, type = '') {
        commit('setFromPage', type);
    },
    upProtocolStatus({ commit }, status = 0) {
        commit('setProtocolStatus', status);
    },
};
const accountModule = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
export default accountModule;
